import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { MDBDataTable, MDBBtn } from "mdbreact";
import { adminActions } from "../../../redux/actions";
import Pagination from "../../includes/Pagination";
import PrimaryLoader from "../../includes/Loaders/PrimaryLoader";
import TableLoader from "../../includes/Loaders/TableLoader";
import ReuseableSearchBar from "../../search/search";
import PageNumber from "../../includes/PageNumber";

export default function All() {
  const dispatch = useDispatch();
  const { page } = useParams();
  const history = useHistory();

  const loading = useSelector((state) => state.admin.loading);
  const searching = useSelector((state) => state.admin.searching);
  const kycData = useSelector((state) => state.admin.allVerification);

  const [payLoad] = useState({
    end_date: new Date(),
  });

  useEffect(() => {
    dispatch(adminActions.filterHumanVerificationAction(payLoad, page));
  }, [dispatch, page, payLoad]);

  function goToSinglePage(user_id) {
    history.push(`/kyc/single-user/${user_id}`);
  }

  function createTableData() {
    let dataToMap = kycData && kycData.data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((verification, index) => {
        let singleRowArray = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          card: verification.document_type,
          number: verification.document_number,
          status: verification.status,
          date: moment(verification.created_at).format("MMM DD, YYYY"),
          action: (
            <MDBBtn onClick={() => goToSinglePage(verification.user_id)}>
              View Details
            </MDBBtn>
          ),
          verificationData: verification,
        };
        outputArray.push(singleRowArray);
        return true;
      });
      return outputArray;
    }
  }
  const dataSet = createTableData();

  const data = {
    columns: [
      {
        label: "S/N",
        field: "num",
        sort: "asc",
        width: 150,
      },
      {
        label: "Identity Card",
        field: "card",
        sort: "asc",
        width: 100,
      },
      {
        label: "ID Card Number",
        field: "number",
        sort: "asc",
        width: 150,
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 100,
      },
      {
        label: "Created On",
        field: "date",
        sort: "asc",
        width: 150,
      },
      {
        label: "Action",
        field: "action",
        sort: "asc",
        width: 150,
      },
    ],
    rows: dataSet,
  };

  return (
    <>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className="main-content">
          <div className=" d-flex justify-content-between  align-items-center flex-wrap mb-3">
            <h1 className="mr-2">KYC Details</h1>
          </div>
          <div className="separator-breadcrumb border-top" />
          <div className="search-page">
            <PageNumber data={kycData} route="kyc/all" />
            <ReuseableSearchBar
              // companyId={company_id}
              page={page}
              searchAction={adminActions.searchHumanVerificationAction}
              clearSearchResultsAction={adminActions.filterHumanVerificationAction(
                payLoad,
                1
              )}
            />
          </div>

          <div>
            {loading || searching ? (
              <TableLoader />
            ) : (
              <MDBDataTable
                responsive
                entries={8}
                entriesOptions={[8, 10, 15]}
                bordered
                theadColor="MDBTableHeader"
                hover
                noBottomColumns
                data={data}
                paging={false}
                searching={false}
              />
            )}
          </div>
          <Pagination data={kycData} route="kyc/all" />
        </div>
      )}
    </>
  );
}
